<template>
    <template v-if="state === State.Hidden">
        <slot name="hidden" />
    </template>

    <template v-if="state === State.Minimized">
        <slot name="minimized" />
    </template>

    <template v-if="state === State.Opened">
        <slot name="opened" />
    </template>
</template>

<script setup lang="ts">
    import useWidgetState, { State } from '@/composables/useWidgetState';

    const { state } = useWidgetState();
</script>
